export default [
  {
    path: '/admin/job-details',
    name: 'job-detail',
    meta: { requiresAuth: true },
    component: () => import('@/pages/human-resource/job-detail')
  }
]
